import { render, staticRenderFns } from "./StartUpWizard.vue?vue&type=template&id=00b1164c&scoped=true&"
import script from "./StartUpWizard.vue?vue&type=script&lang=js&"
export * from "./StartUpWizard.vue?vue&type=script&lang=js&"
import style0 from "./StartUpWizard.vue?vue&type=style&index=0&id=00b1164c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1164c",
  null
  
)

export default component.exports